import $ from 'jquery';

const clearState = $container => {
    $container.find('.trigger.open').removeClass('open');
    $container.find('.mega-menu-links > .container .item').addClass('hide');
};

const megaMenu = $container => {
    const hoverSearchTriggerMark = 'hover-search-trigger';
    const searchTrigger = 'js-search-bar-trigger';
    let removeClassAnimeContent;
    let removeClassAnime;
    let closeHoverMenu;
    let addClassAnime;

    const showMegaMenu = $el => {
        clearTimeout(removeClassAnimeContent);
        clearTimeout(removeClassAnime);
        clearTimeout(closeHoverMenu);
        $container.addClass('mega-menu-hover');

        // special for search button
        // i think this should on click since the icon is x on active
        if ($el.closest(`.${searchTrigger}`).length > 0) {
            $container.addClass(hoverSearchTriggerMark);
        }

        // onhover on trigger
        if ($el.hasClass('trigger')) {
            clearState($container);

            // add anim class
            addClassAnime = setTimeout(() => {
                $container.addClass('animate-mega-menu-box animate-mega-menu-content');
            }, 1);

            // open state trigger
            $el.addClass('open');

            // visible state mega menu
            const $currentContent = $container.find(`#${$el.data('menu')}`);
            $currentContent.removeClass('hide');

            // special for search form; clear and set focus
            if ($currentContent.hasClass('js-search-bar-trigger')) {
                $currentContent.find('#search-input').val('').change().focus();
            }

            // move hover state
            const $hoverState = $container.find('.hover-state');
            const $li = $el.closest('li');
            const elLef = $li.offset().left;
            const elWidth = $li.outerWidth();
            $hoverState.css({
                left: elLef,
                width: elWidth,
                height: $el.closest('ul').outerHeight()
            });

            // set static height for animation
            const $contentContainer = $container.find('.mega-menu-links');
            const contentHeight = $currentContent.outerHeight();
            const containerPadding = $contentContainer.css('paddingBottom').replace('px', '') * 2;
            $contentContainer.css('height', contentHeight + containerPadding);
        } else if ($el.closest('.desktop-mega-menu-child').length === 0) {
            $el.trigger('blur');
        }

        removeClassAnimeContent = setTimeout(() => {
            $container.removeClass('animate-mega-menu-content');
        }, 300);
    };

    const hideMegaMenu = () => {
        $container.removeClass(hoverSearchTriggerMark);
        clearTimeout(addClassAnime);

        removeClassAnime = setTimeout(() => {
            $container.removeClass('animate-mega-menu-box');

            closeHoverMenu = setTimeout(() => {
                clearState($container);

                $container.removeClass('mega-menu-hover open-search-bar');
            }, 250);
        }, 300);
    };

    $container.on('mouseenter focus', '.desktop-mega-menu a, .desktop-mega-menu-child .item', function () {
        const $el = $(this);
        if ($el.closest(`.${searchTrigger}`).length > 0) return;
        if ($el.hasClass(searchTrigger)) return;

        $container.removeClass(hoverSearchTriggerMark);
        showMegaMenu($(this));
    }).on('mouseleave blur', '.desktop-mega-menu a, .desktop-mega-menu-child .item', function () {
        const $el = $(this);
        if ($el.closest(`.${hoverSearchTriggerMark}`).length > 0) return;
        if ($el.hasClass(searchTrigger)) return;

        hideMegaMenu();
    }).on('click', '.desktop-mega-menu a', function (e) {
        e.preventDefault();
        const $el = $(this);

        if ($el.closest(`.${hoverSearchTriggerMark}`).length > 0 || $el.closest('.mega-menu-hover') > 0) {
            hideMegaMenu();
        } else {
            showMegaMenu($(this));
        }
    });

    $(window).resize(() => {
        hideMegaMenu();
    });
};

$(() => {
    const $widget = $('.s-desktop-header:not(.openday-version)');

    if ($widget.length) {
        $widget.each(function () {
            megaMenu($(this));
        });
    }
});
